/* Style Mobo — desktop hover-to-open for the mega menu (in addition to click) */
(function () {
  function initHoverMegaMenu() {
    var desktop = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('header-menu').forEach(function (menu) {
      var details = menu.querySelector('details.mega-menu');
      if (!details) return;

      var summary = details.querySelector('summary');
      var closeTimer;

      menu.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        details.open = true;
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseleave', function () {
        if (!desktop.matches) return;
        closeTimer = setTimeout(function () {
          details.open = false;
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMegaMenu);
  } else {
    initHoverMegaMenu();
  }
})();
